import React from 'react';
import '../styles/HomePage.css';

function HomePage() {
  return (
    <div className="homepage">
      <div className="hero-section">
        <div 
          className="hero-image" 
          style={{
            backgroundImage: `url(${require('../assets/hero-image.jpg')})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        >
          <div className="hero-overlay">
            <div className="hero-content">
              <div className="hero-logo">
                <img 
                  src={require('../assets/vinland-logo.png')} 
                  alt="Vinland Logo" 
                  className="logo-image"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePage;
